import React from 'react';

import { SVGComponentProps } from './svg.types';

const UpcomingDeadlineDateSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 3.16665H11.3333V2.49998C11.3333 2.32317 11.2631 2.1536 11.1381 2.02858C11.013 1.90355 10.8435 1.83331 10.6667 1.83331C10.4899 1.83331 10.3203 1.90355 10.1953 2.02858C10.0702 2.1536 10 2.32317 10 2.49998V3.16665H6V2.49998C6 2.32317 5.92976 2.1536 5.80474 2.02858C5.67971 1.90355 5.51014 1.83331 5.33333 1.83331C5.15652 1.83331 4.98695 1.90355 4.86193 2.02858C4.7369 2.1536 4.66667 2.32317 4.66667 2.49998V3.16665H4C3.46957 3.16665 2.96086 3.37736 2.58579 3.75243C2.21071 4.12751 2 4.63621 2 5.16665V13.1666C2 13.6971 2.21071 14.2058 2.58579 14.5809C2.96086 14.9559 3.46957 15.1666 4 15.1666H12C12.5304 15.1666 13.0391 14.9559 13.4142 14.5809C13.7893 14.2058 14 13.6971 14 13.1666V5.16665C14 4.63621 13.7893 4.12751 13.4142 3.75243C13.0391 3.37736 12.5304 3.16665 12 3.16665ZM4 4.49998H4.66667V5.16665C4.66667 5.34346 4.7369 5.51303 4.86193 5.63805C4.98695 5.76307 5.15652 5.83331 5.33333 5.83331C5.51014 5.83331 5.67971 5.76307 5.80474 5.63805C5.92976 5.51303 6 5.34346 6 5.16665V4.49998H10V5.16665C10 5.34346 10.0702 5.51303 10.1953 5.63805C10.3203 5.76307 10.4899 5.83331 10.6667 5.83331C10.8435 5.83331 11.013 5.76307 11.1381 5.63805C11.2631 5.51303 11.3333 5.34346 11.3333 5.16665V4.49998H12C12.1768 4.49998 12.3464 4.57022 12.4714 4.69524C12.5964 4.82027 12.6667 4.98984 12.6667 5.16665V7.83331H3.33333V5.16665C3.33333 4.98984 3.40357 4.82027 3.5286 4.69524C3.65362 4.57022 3.82319 4.49998 4 4.49998ZM12 13.8333H4C3.82319 13.8333 3.65362 13.7631 3.5286 13.6381C3.40357 13.513 3.33333 13.3435 3.33333 13.1666V9.16665H12.6667V13.1666C12.6667 13.3435 12.5964 13.513 12.4714 13.6381C12.3464 13.7631 12.1768 13.8333 12 13.8333Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default UpcomingDeadlineDateSVG;
